export default class WrongCredentialsError extends Error {
  static CODE = 'wrong-credentials'

  constructor(headers={}, ...args) {
    super(...args)

    const loginAttemptsLeft = headers['tt_login_attempts_left']

    this.code = WrongCredentialsError.CODE
    this.loginAttemptsLeft = loginAttemptsLeft === undefined ? null : loginAttemptsLeft
  }
}
